export default __webpack_public_path__ + "static/media/dash-job-diva.c15f022d.svg";